"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * Simple React hook that returns a boolean;
 * true at mount time otherwise it is false.
 */
function useIsFirstRender() {
    const isFirst = (0, react_1.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
exports.default = useIsFirstRender;
//# sourceMappingURL=useIsFirstRender.js.map